import { supabase } from "@/integrations/supabase/client";
import type { Profile } from "@/contexts/auth-context-core";

function mapProfile(profile: {
  id: string;
  user_id: string;
  full_name: string | null;
  avatar_url: string | null;
  is_verified: boolean | null;
  created_at: string;
  updated_at: string;
}): Profile {
  return {
    id: profile.id,
    user_id: profile.user_id,
    full_name: profile.full_name || "",
    avatar_url: profile.avatar_url,
    is_verified: profile.is_verified ?? false,
    created_at: profile.created_at,
    updated_at: profile.updated_at,
  };
}

export async function fetchUserRole(userId: string): Promise<string | null> {
  const roleRes = await supabase.rpc("get_my_role", { p_user_id: userId });

  let finalRole: string | null = typeof roleRes.data === "string" ? roleRes.data : null;

  if (!finalRole) {
    const { data: directRole } = await supabase
      .from("user_roles")
      .select("role")
      .eq("user_id", userId)
      .limit(1)
      .maybeSingle();

    finalRole = directRole?.role || null;
  }

  return finalRole;
}

export async function fetchUserProfile(userId: string): Promise<Profile | null> {
  const { data } = await supabase
    .from("profiles")
    .select("*")
    .eq("user_id", userId)
    .limit(1)
    .maybeSingle();

  if (!data) {
    return null;
  }

  return mapProfile(data);
}
